import css from 'styled-jsx/css';

export default css`.left-content {
    width: 100%;
    height: 100%;
    img {
        width: 100%;
        height: 100%;
    }
}

`